import { create, StateCreator } from 'zustand';
import { useSnackbarStore } from './useSnackbarStore';

interface ErrorState {
  error: string | null;
  setError: (error: string | null) => void;
  clearError: () => void;
}

const errorMiddleware = (config: StateCreator<ErrorState>): StateCreator<ErrorState> =>
  (set, get, api) =>
    config((partial) => {
      const msg = (partial as Partial<ErrorState>).error;
      if (msg) {
        console.error(msg);
        useSnackbarStore.getState().showSnackbar(msg, 'danger');
      }
      set(partial);
    }, get, api);

export const useErrorStore = create<ErrorState>(
  errorMiddleware((set) => ({
    error: null,
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
  }))
);
